import React from 'react';
import styled from 'styled-components';
import { Card } from 'react-bootstrap';

const TopicGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 16px;
  margin-top: 20px;
`;

const TopicCard = styled(Card)`
  border-radius: 16px;
  border: none;
  padding: 16px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);
  font-family: 'Nunito Sans', sans-serif;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    background-color: #fff;
  }
`;

const Heading = styled.h5`
  font-weight: bold;
  color: #232830;
  margin-bottom: 12px;
  font-family: 'Nunito Sans', sans-serif;
`;

const SubHeading = styled.p`
  font-size: 15px;
  color: #6c757d;
  margin-bottom: 20px;
  font-family: 'Nunito Sans', sans-serif;
`;

const topics = [
    { id: 'tech-q1', keyword: 'price action', question: 'What is the price action here?', category: 'Technical' },
    { id: 'tech-q2', keyword: 'trend zones', question: 'What is the current trend?', category: 'Technical' },
    { id: 'tech-q3', keyword: 'support level', question: 'What are the support levels?', category: 'Technical' },
    { id: 'tech-q4', keyword: 'resistance level', question: 'What are the resistance levels?', category: 'Technical' },
    { id: 'tech-q5', keyword: 'pattern', question: 'What is the technical pattern?', category: 'Technical' },
    // ...
  ];
  

  // Inside AskChartTopics.jsx
const AskChartTopics = ({ onTopicClick }) => {
    return (
      <div className="mt-4">
        {/* <Heading>Check the Market Sentiment</Heading> */}
        <SubHeading>Tap a topic to explore. FinTorro Pro required to unlock full access.</SubHeading>
  
        <TopicGrid>
          {topics.map((topic) => (
            <TopicCard key={topic.id} onClick={() => onTopicClick(topic)}>
              <Card.Body style={{ fontSize: '15px', color: '#232830' }}>
                {topic.keyword}
              </Card.Body>
            </TopicCard>
          ))}
        </TopicGrid>
      </div>
    );
  };
  
  

export default AskChartTopics;
